import {Button, Space} from 'antd';
import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {DATA_MODULE} from 'modules/data';
import {setData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {TAppState} from 'store/config/types';

interface IActionDeleteCellProps {
    entityName: string;
    record: any;
    text?: string;
}

export const ActionDeleteCell: FC<IActionDeleteCellProps> = ({
    entityName,
    record,
    text = 'Удалить',
}: IActionDeleteCellProps) => {
    const dispatch = useDispatch();
    const data = useSelector(
        (state: TAppState) => state[DATA_MODULE]?.[entityName]?.[EEntityType.TABLE].rows,
    );
    const handlerClick = () => {
        const newData = data?.filter(item => record.id !== item?.id);
        dispatch(setData({
            entityName,
            entityType: EEntityType.TABLE,
            loading: false,
            data: {
                rows: newData,
            },
        }));
    };

    return (
        <Space size="middle">
            <Button
                type="link"
                onClick={handlerClick}
            >
                {text}
            </Button>
        </Space>
    );
};
